module.exports = __webpack_public_path__ + "static/media/Plus.f4c70127.svg";